import { QSetReviewTaskCreationProvider } from '@exam-management/qset-review-task-creation';
import { Outlet } from 'react-router-dom';

export default function TaskManagementQSetReviewLayout() {
  return (
    <QSetReviewTaskCreationProvider>
      <Outlet />
    </QSetReviewTaskCreationProvider>
  );
}
